import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopProjectInfoResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopProjectInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.ProjectInfoRequest), switchMap(function (action) {
        var playerId = action.playerId, coopId = action.coopId, projectId = action.projectId;
        return deps
            .notificationNetSend({
            id: CommandCode.CoopProjectInfo,
            props: {
                coopId: coopId,
                playerId: playerId,
                projectId: projectId,
            },
        })
            .pipe(map(actionCoopProjectInfoResponse), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopProjectInfo.ts
// module id = 1819
// module chunks = 3